/**
 * encrypted-credentials-authorization-provider.js
 *
 * Copyright (c) apploft. GmbH
 */

import crypto from 'crypto';

const ERR_NO_PUBLIC_KEY = 'no public key provided';
const ENCRYPTION_METHOD = 'billoRSA';

export default class EncryptedCredentialsAuthorizationProvider {
  constructor(publicKey) {
    if (!publicKey) {
      throw new Error(ERR_NO_PUBLIC_KEY);
    }
    this.publicKey = publicKey;
  }

  createAuthorization({username, password}) {
    const plaintext = Buffer.from(JSON.stringify({username, password}), 'utf8');
    const ciphertext = crypto.publicEncrypt(this.publicKey, plaintext);
    return {
      encryptionMethod: ENCRYPTION_METHOD,
      base64Data: ciphertext.toString('base64'),
    };
  }
}
